import { useTranslation } from "react-i18next";

export default function Werkwijze() {
  const { t } = useTranslation("velux-reparatie");
  const steps = t("werkwijze.steps", { returnObjects: true }) as Array<{
    num: string;
    title: string;
    text: string;
  }>;

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("werkwijze.h2")}
        </h2>
        <div className="relative max-w-[900px] mx-auto">
          <div className="hidden md:block absolute top-6 left-[12.5%] right-[12.5%] h-0.5 bg-brand-yellow"></div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-6">
            {steps.map((step, i) => (
              <div key={i} className="flex flex-col items-center text-center">
                <div className="w-12 h-12 rounded-full bg-brand-blue text-white flex items-center justify-center font-geist-mono font-bold text-sm mb-4 relative z-10">
                  {step.num}
                </div>
                <h3 className="font-geist font-bold text-base md:text-lg text-brand-text mb-1">
                  {step.title}
                </h3>
                <p className="font-geist text-sm text-brand-text/70 leading-relaxed">
                  {step.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}